<div class="otp-verification-wrapper">
  <div class="otp-container">
    <div class="otp-inputs-wrapper" role="group" aria-label="OTP digits">
      <input
        *ngFor="let i of otpIndexes; trackBy: trackByIndex"
        #otpCell
        type="text"
        inputmode="numeric"
        maxlength="1"
        class="otp-input"
        placeholder="*"
        [id]="'otp-cell-' + i"
        [name]="'otp-cell-' + i"
        [attr.data-index]="i"
        [value]="cellValues[i]"
        [readonly]="isVerifying || disabled"
        [attr.aria-label]="'OTP digit ' + (i + 1) + ' of 6'"
        (input)="onCellInput($event, i)"
        (keydown)="onCellKeyDown($event, i)"
        (paste)="onCellPaste($event, 0)"
        autocomplete="off"
      />
    </div>
    <div class="otp-hint-wrapper">
      <span class="otp-hint"
            [class.resend-otp-hint]="countdown < 0 && !isResending && !isVerifying && !disabled"
            (click)="onResendClick()">
        <ng-container *ngIf="countdown >= 0; else resendActive">
          Resend in {{ countdown }}s
        </ng-container>
        <ng-template #resendActive>
          Resend
        </ng-template>
      </span>
    </div>
  </div>

  <div class="otp-meta d-flex flex-column align-items-center">
    <small *ngIf="errorMsg" class="form-error-msg-text text-center" [innerHTML]="errorMsg"></small>
    <small *ngIf="maxAttempts > 0 && attemptsRemaining > 0 && attemptsRemaining < maxAttempts"
           class="otp-attempts-text text-center">
      {{ attemptsRemaining }} {{ attemptsRemaining === 1 ? 'attempt' : 'attempts' }} remaining
    </small>
  </div>

  <div class="otp-actions d-flex justify-content-center align-items-center flex-column" *ngIf="showVerifyButton">
    <button mat-flat-button color="primary" class="verify-otp-btn"
            type="button"
            *ngIf="!isVerifying"
            [disabled]="(effectiveControl.value ?? '').length !== 6 || disabled"
            (click)="onVerifyClick()">
      {{ verifyButtonLabel }}
    </button>
    <mat-icon *ngIf="isVerifying"><mat-spinner diameter="24"></mat-spinner></mat-icon>
  </div>
</div>
